import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Container, Row } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import Error from "../../Components/Common/Error";
import Loader from "../../Components/Common/Loader";
import AddClientModal from "../../Components/ManageClients/AddClientModal";
import AddContactPersonModal from "../../Components/ManageClients/AddContactPersonModal";
import ClientCard from "../../Components/ManageClients/ClientCard";
import { getClients } from "../../slices/ManageClient/thunk";

const ManageClients = () => {

    const dispatch = useDispatch();
    const { isLoading, isError, clientsList } = useSelector(state => state.GetAllClients);

    const [addClentModalOpen, setAddClentModalOpen] = useState(false);
    const handleAddClientModal = () => {
        setAddClentModalOpen(!addClentModalOpen);
    }

    const [clientCompanyId, setClientCompanyId] = useState();
    const [contactPersonAddModalOpen, setcontactPersonAddModalOpen] = useState(false);
    const toggleContactPersonAddModal = (id) => {
        setClientCompanyId(id)
        setcontactPersonAddModalOpen(!contactPersonAddModalOpen);
    };

    useEffect(() => {
        dispatch(getClients());
    }, [dispatch]);

    if (isLoading) return <Loader />

    if (isError) return <Error />

    return (
        <>

            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={'Manage Clients'} pageTitle={"Dashboard"} />

                    <Row className="g-4 mb-2">
                        <div className="col-sm-auto pe-1 ps-1">
                            <div>
                                <Button className="btn btn-success btn-sm" onClick={handleAddClientModal}><i
                                    className="ri-add-line align-bottom me-1"></i> Add New</Button>
                            </div>
                        </div>
                    </Row>

                    <Row>
                        {
                            clientsList && clientsList.map((data, index) => (
                                <ClientCard data={data} key={index} toggleContactPersonAddModal={toggleContactPersonAddModal}/>
                            ))
                        }
                    </Row>

                </Container>

                <AddClientModal
                    addClentModalOpen={addClentModalOpen}
                    setAddClentModalOpen={setAddClentModalOpen}
                    handleAddClientModal={handleAddClientModal}
                />

                <AddContactPersonModal
                    contactPersonAddModalOpen={contactPersonAddModalOpen}
                    setcontactPersonAddModalOpen={setcontactPersonAddModalOpen}
                    toggleContactPersonAddModal={toggleContactPersonAddModal}
                    clientCompanyId={clientCompanyId}
                />

            </div>
        </>
    );
};

export default ManageClients;